import React from 'react';
import './DoctorRouteDialog.css';

interface DoctorRouteDialogProps {
  /** OK ボタン押下時のハンドラ */
  onConfirm: () => void;
}

/**
 * ドクタールートに切り替わった場合に表示するモーダルダイアログ。
 *
 * - フルスクリーンオーバーレイ + 中央カード
 * - メッセージと OK ボタンのみ
 * - × ボタンや外側タップで閉じる手段は提供しない（OK 押下のみで終了）
 */
export const DoctorRouteDialog: React.FC<DoctorRouteDialogProps> = ({ onConfirm }) => {
  return (
    <div className="doctor-route-dialog-overlay" role="dialog" aria-modal="true">
      <div className="doctor-route-dialog">
        <p className="doctor-route-dialog-message">
          homeKarteでは操作できません。
          <br />
          ホーム画面に戻ります。
        </p>
        <button
          type="button"
          className="button-primary doctor-route-dialog-button"
          onClick={onConfirm}
        >
          OK
        </button>
      </div>
    </div>
  );
};
